export const SAVE = 'stepOther.SAVE';
export const VALUE_CHANGED = 'stepOther.VALUE_CHANGED';
export const LOAD = 'stepOther.VALUE_LOAD';
export const NEXT = 'stepOther.NEXT';
export const RESET = 'stepOther.RESET';
export const RESET_SUB_BENEFIT = 'stepOther.RESET_SUB_BENEFIT';
export const RESET_BENEFIT_OTHER = 'stepOther.RESET_BENEFIT_OTHER';
export const RESET_ACCIDENTAL_DEATH_AND_DISMEMBERMENT = 'stepOther.RESET_ACCIDENTAL_DEATH_AND_DISMEMBERMENT';
export const RESET_BURIAL = 'stepOther.RESET_BURIAL';
export const RESET_REPATRIATION = 'stepOther.RESET_REPATRIATION';
export const RESET_PERSONAL_LIABILITY = 'stepOther.RESET_PERSONAL_LIABILITY';
export const RESET_PERSONAL_ACCIDENT = 'stepOther.RESET_PERSONAL_ACCIDENT';
export const RESET_LOSS_OF_INCOME = 'stepOther.RESET_LOSS_OF_INCOME';
export const RESET_TOTAL_PERMANENT_DISABLEMENT = 'stepOther.RESET_TOTAL_PERMANENT_DISABLEMENT';
export const RESET_LOSS_OF_LIFE = 'stepOther.RESET_LOSS_OF_LIFE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '7',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOther/constants.js